import React from 'react'
import PropTypes from 'prop-types'
import { Label as BsLabel } from 'components/qstrap'

const Label = (props) => {
  if (props.text) {
    return (
      <BsLabel for={props.name}>
        {props.text}
      </BsLabel>
    )
  }

  return null
}

Label.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
}

export default Label
